import {Component, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle} from '@ng-bootstrap/ng-bootstrap';
import {ToastsContainer} from '../../../shared/commons/toast/toast-container.component';
import {LoadingComponent} from '../../../shared/commons/loading/loading.component';
import {NotificationBellComponent} from '../../../shared/commons/notification-bell/notification-bell.component';
import {ActingAsBannerComponent} from '../../../shared/commons/acting-as-banner/acting-as-banner.component';

@Component({
  selector: 'app-admin-layout-mobile',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    ToastsContainer,
    LoadingComponent,
    NotificationBellComponent,
    ActingAsBannerComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
  ],
  templateUrl: './admin-layout-mobile.html',
  styleUrls: ['../admin-layout.scss', './admin-layout-mobile.scss'],
})
export class AdminLayoutMobileComponent {
  readonly sidebarOpen = input.required<boolean>();
  readonly profileIncomplete = input.required<boolean>();
  readonly canSeeDashboard = input<boolean>(false);
  readonly canSeeProfile = input<boolean>(false);
  readonly canSeePurchaseSale = input<boolean>(false);
  readonly canSeeQrTrace = input<boolean>(false);
  readonly canSeeChat = input<boolean>(false);
  readonly canSeeSurvey = input<boolean>(false);
  readonly canSeeObservations = input<boolean>(false);
  readonly canSeeBusinessTypeSettings = input<boolean>(false);
  /** /trade pages other than the officer report (see AdminLayout.tradeMenuActive). */
  readonly tradeMenuActive = input<boolean>(false);
  readonly fullScreenRoute = input.required<boolean>();
  readonly fullMainRoute = input.required<boolean>();
  readonly chatUnreadCount = input.required<number>();
  readonly pendingInvitationCount = input<number>(0);
  readonly userName = input<string | undefined>(undefined);
  readonly userEmail = input<string | undefined>(undefined);
  readonly userRole = input<string | undefined>(undefined);
  readonly userAvatar = input<string | null>(null);

  readonly toggleSidebar = output<void>();
  readonly closeSidebar = output<void>();
  readonly logout = output<void>();
  readonly navigateToOidcAccountInfo = output<void>();
  readonly goToPortalSystem = output<void>();
}
